





























import Vue, { PropType } from 'vue';
import TheDeviceTargets from '@/components/campaign/targets/TheDeviceTargets.vue';
import TheAudiences  from '@/components/campaign/targets/TheAudiences.vue';
import TheBlackWhiteList from '@/components/campaign/targets/TheBlackWhiteList.vue';
import TheFrequencyCapping from '@/components/campaign/targets/TheFrequencyCapping.vue';
import { CampaignTargetsInterface } from '@/types/campaign/targets';
import Preloader from '@/components/preloader/Preloader.vue';
import TheContextualTarget from '@/components/campaign/targets/TheContextualTarget.vue';

export default Vue.extend({
  name: 'TheTargets',
  components: {
    TheDeviceTargets,
    TheBlackWhiteList,
    TheFrequencyCapping,
    Preloader,
    TheContextualTarget
  },

  props: {
    data: {
      type: Object as PropType<CampaignTargetsInterface>,
      required: true,
    },
  },

  methods: {
    changeCampaign(name, value) {
      this.$emit('changeCampaign', name, value);
    },
    changeForm(name, value) {
      this.$emit('changeForm', name, value);
    },
  },
});
